import { NgClass } from '@angular/common';
import { Component, Input, output, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { environment } from '@environments/environment';
import { TranslateModule } from '@ngx-translate/core';
import { AddRequiredPipe } from '@pipe/add-required.pipe';

@Component({
  selector: 'app-email-step',
  templateUrl: './email-step.component.html',
  imports: [FormsModule, NgClass, TranslateModule, AddRequiredPipe]
})
export class EmailStepComponent {

  @Input('emailFormError') set emailForm(reset: boolean) {
    reset && this.resetEmailForm();
  };
  // JB-1686: pre-fill when the user returns here to correct a mistyped email
  // (via "wrong email? edit it" on the OTP screen), so it isn't retyped.
  @Input() set prefillEmail(email: string) {
    if (email) {
      this.emailAddress$.set(email);
    }
  }

  protected onNextEvent = output<string>();

  protected readonly redirectUrl = environment.redirectDomain;

  protected emailAddress$ = signal('');
  protected showLoader$ = signal(false);

  private resetEmailForm(): void {
    this.showLoader$.set(false);
  }

  protected nextStep(): void {
    this.showLoader$.set(true);
    this.onNextEvent.emit(this.emailAddress$());
  }
}
